import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {isEmptyVariable, isEmptyArray, isAlphaNumericCharacter, hasFeatureAccess, getLocalStorageVariables, handleTokenExpiry} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import RegularDropdown from '../../../common/DropdownMenus/RegularDropdown';
import {DialogSaveButton,FilterCheckBox,TableRadioButton} from '../../../common/Global/globalStyles.style';
import * as TemplateConstants from "../../../common/Global/templateConstants";
import AddDropdownValuesDialog from './addDropdownValuesDialog';
import AddDescriptionDialog from './addDescriptionDialog';
import ReactSelectDropdown from '../../../common/DropdownMenus/ReactSelectDropdownWithSearch';
import AddFrameworkDialog from './addFrameworkDialog';

const fieldTypePlaceholderText = "Select Field Type";
const execTaskTablePlaceholderText = "Select Execute Task Table";
const frameworkTypePlaceholderText = "Select Framework Type";
const masterTypePlaceholderText = "Select Master Type";
let userDetails = getLocalStorageVariables();
const maximumScorePlaceholderText = "Select Maximum Score";
const maximumWeightPlaceholderText = "Select Maximun Weight";

class AddFieldDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,
            fieldName:"",
            fieldType:fieldTypePlaceholderText,
            selectedExecTaskTableFieldName:execTaskTablePlaceholderText,
            selectedExecTaskTableFieldId:"",
            fieldTypeArr:[],
            placeholderValue:"",
            dropdownValues:[],
            formErrors:{},
            submitClickedAtleastOnce:false,
            notRequiredOption_NR:"",
            isMandatorySelected:"",
            isUsedForExec:"",
            userOnlyField:"N",
            observationHeading:"N",
            observationHeadingFormat:{bold:false,italic:false,underline:false},
            showFieldHeading:"N",
            executiveSummary:"N",
            riskLevelExecutiveSummary:"N",
            showDescription:"N",
            showDescriptionSeparator:"N",
            descriptionSeparator:"",
            showOnlyDescription:"N",
            showCreateDDValueDialog:false,
            canBeDeleted:"",
            isDisplayFramework:false,
            selectedFrameworkType:frameworkTypePlaceholderText,
            selectedMasterType:masterTypePlaceholderText,
            masterSelectionType:"",
            masterNameOrder:"1",
            masterShortNameOrder:"",
            masterDescriptionOrder:"",
            // Employee's Title/Name/Designation are plain show/hide toggles, not an orderable sequence,
            // so they get their own Y/N flags instead of reusing the Designation master's order fields.
            // Title's checkbox can't be unchecked, so it's always "Y".
            masterShowEmployeeTitle:"Y",
            masterShowEmployeeName:"N",
            masterShowEmployeeDesignation:"N",
            masterShowDisplaySeparator:"N",
            masterDisplaySeparator:"",
            masterRemarksType:"",
            masterReportNameFormat:{bold:false,italic:false,underline:false},
            masterReportShortNameFormat:{bold:false,italic:false,underline:false},
            masterReportDescriptionFormat:{bold:false,italic:false,underline:false},
            masterReportTitleFormat:{bold:false,italic:false,underline:false},
            masterReportEmployeeNameFormat:{bold:false,italic:false,underline:false},
            masterReportDesignationFormat:{bold:false,italic:false,underline:false},

            frameworkTypeArr:[
                {value:"Internal"},
                {value:"Standard"},
            ],
            frameworkArr:[],
            selectedFrameworkObj:[],
            selectedMaximumScore:maximumScorePlaceholderText,
            selectedMaximumWeight:maximumWeightPlaceholderText,
            selectedDecimalValue:"",
            isDecimalAllowed:"N",
            showDescriptionDialog:false,
            descriptions:{},
            showScoreDescription:false
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    // React lifecycle method: Called after component updates.
    // Handles initialization of dropdown options and state based on props.
    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showCreateDialog){
            // Set field type dropdown options based on template type and position:
            let fieldTypeArr = [];
            let frameworkTypeArr = this.state.frameworkTypeArr;
            // hasTaskTemplateScore is used to determine if both Weighted Score and Maximum Score fields are already present in the template.
            let hasTaskTemplateScore = false;

            // Check feature access permissions
            const hasTaskTableAccess = hasFeatureAccess(Constants.FEATURE_TASK_TEMPLATE_TABLE);
            const hasNumericFieldAccess = hasFeatureAccess(Constants.FEATURE_OBSERVATION_TEMPLATE_FIELD_NUMERIC);
            const hasValueAdditionAccess = hasFeatureAccess(Constants.FEATURE_OBSERVATION_TEMPLATE_VALUE_ADDITION);
            const hasExecuteNumericAccess = hasFeatureAccess(Constants.FEATURE_EXECUTE_TEMPLATE_NUMERIC);
            const hasExecuteValueAdditionAccess = hasFeatureAccess(Constants.FEATURE_EXECUTE_TEMPLATE_VALUE_ADDITION);
            const hasWeightedFeature = hasFeatureAccess(Constants.FEATURE_TASK_TEMPLATE_FIELD_WEIGHT);
            const hasMaxScoreFeature = hasFeatureAccess(Constants.FEATURE_TASK_TEMPLATE_FIELD_MAX_RATE);

            // Handle Response Templates
            if (this.props.templateType === TemplateConstants.TEMPLATE_TYPE_AUDITEE_COMMENT) {
                fieldTypeArr = TemplateConstants.FIELD_TYPES_AUDITEE_COMMENT;
            }else if(this.props.addToPosition === "Right" && this.props.templateType === TemplateConstants.TEMPLATE_TYPE_TASK){
                fieldTypeArr = TemplateConstants.FIELD_TASK_TYPES_ARR
            }
            // Handle Right Position for Non-Execution Templates
            else if(this.props.addToPosition ==="Right" && this.props.templateType !== TemplateConstants.TEMPLATE_TYPE_EX_TASK){
                // If it's task template and table is not allowed then remove table from field type dropdown
                if(this.props.templateType === TemplateConstants.TEMPLATE_TYPE_TASK && !hasTaskTableAccess){
                    // Remove table field option if feature access is not available
                    fieldTypeArr = TemplateConstants.FIELD_TYPES_ARR.filter(item => item.value !== TemplateConstants.FIELD_TYPE_TABLE);
                } 
                // Observation Template with numeric/value addition restrictions
                else if(this.props.templateType === TemplateConstants.TEMPLATE_TYPE_OBSERVATION){
                    fieldTypeArr = TemplateConstants.OBSERVATION_FIELD_TYPES_ARR.filter(item => {
                        // Remove numeric field if no feature access
                        if (item.value === TemplateConstants.FIELD_TYPE_NUMERIC && !hasNumericFieldAccess) return false;
                        return true;
                    });
                }
                // General (Assignment Level) Template also supports the Master field type.
                else if(this.props.templateType === TemplateConstants.TEMPLATE_TYPE_GENERAL){
                    fieldTypeArr = TemplateConstants.GENERAL_FIELD_TYPES_ARR;
                }
                // Otherwise, show all field types.
                else{
                    fieldTypeArr = TemplateConstants.FIELD_TYPES_ARR;
                }
            }
            // Handle Right Position for Execution Task Templates
            else if(this.props.addToPosition ==="Right" && this.props.templateType === TemplateConstants.TEMPLATE_TYPE_EX_TASK){
                fieldTypeArr = TemplateConstants.EX_TASK_FIELD_TYPES_ARR.filter(item => {
                    // If "Score" is already present, remove "Score" from dropdown.
                    // if(item.value === TemplateConstants.FIELD_TYPE_SCORE && this.props.hasScore) return false;
                    // Remove numeric field if no feature access
                    if(item.value === TemplateConstants.FIELD_TYPE_NUMERIC && !hasExecuteNumericAccess) return false;
                    // Remove value addition field if no feature access
                    if(item.value === TemplateConstants.FIELD_TYPE_VALUE_ADDITION && !hasExecuteValueAdditionAccess) return false;
                    return true;
                });
            }
            // Handle Left Position for All Templates
            else if(this.props.addToPosition === "Left"){
                // Set field type dropdown options for Task Templates based on weighted and max score flags.
                if(this.props.templateType === TemplateConstants.TEMPLATE_TYPE_TASK){
                    const { hasWeighted, hasMaxScore } = this.props;

                    fieldTypeArr = TemplateConstants.FIELD_TYPES_ARR_LEFT.filter(item => {
                        // Handle Weighted Score field:
                        // Show only if feature is available AND not already used
                        if (item.value === TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE) {
                            // Remove if no feature access OR if already used
                            return hasWeightedFeature && !hasWeighted;
                        }
                        
                        // Handle Maximum Score field:
                        // Show only if feature is available AND not already used
                        if (item.value === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE) {
                            // Remove if no feature access OR if already used
                            return hasMaxScoreFeature && !hasMaxScore;
                        }
                        // Hide Value Addition for non-observation templates
                        if (item.value === TemplateConstants.FIELD_TYPE_VALUE_ADDITION) {
                            return false;
                        }
                        return true;
                    });
                } else if(this.props.templateType === TemplateConstants.TEMPLATE_TYPE_OBSERVATION){
                    // For observation templates, show all except Weighted and Maximum Score (keep Value Addition)
                    fieldTypeArr = TemplateConstants.FIELD_TYPES_ARR_LEFT.filter(item => 
                        item.value !== TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE && 
                        item.value !== TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE);
                        fieldTypeArr = fieldTypeArr.filter(item => {
                            // Remove value addition field if no feature access
                            if (item.value === TemplateConstants.FIELD_TYPE_VALUE_ADDITION && !hasValueAdditionAccess) return false;
                            return true;
                        });
                }else{
                    // For non-task templates, always remove weighted and maximum score from the dropdown.
                    fieldTypeArr = TemplateConstants.FIELD_TYPES_ARR_LEFT.filter(item => 
                        item.value !== TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE && 
                        item.value !== TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE &&
                        item.value !== TemplateConstants.FIELD_TYPE_VALUE_ADDITION)
                }
            } 

            // For Execution Templates, set the hasTaskTemplateScore flag from props.
            if(this.props.templateType === TemplateConstants.TEMPLATE_TYPE_EX_TASK){
                hasTaskTemplateScore = this.props.hasTaskTemplateScore;
            }
            
            if(this.props.isEdit){
                let dropdownValues = [];
                if(this.props.editTemplateItem.fieldType  === TemplateConstants.FIELD_TYPE_SINGLE_SELECT ||
                    this.props.editTemplateItem.fieldType  === TemplateConstants.FIELD_TYPE_MULTI_SELECT ||
                    this.props.editTemplateItem.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN ||
                    this.props.editTemplateItem.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI ||
                    this.props.editTemplateItem.fieldType === TemplateConstants.FIELD_TYPE_ISO){
                    dropdownValues = this.props.editTemplateItem.dropdownValues;
                }
                if(this.props.editTemplateItem.fieldType === TemplateConstants.FIELD_TYPE_FRAMEWORK){
                    this.setState({
                        selectedFrameworkType:this.props.editTemplateItem.frameworkType,
                        selectedFrameworkObj:this.props.editTemplateItem.frameworkList
                    },() => {
                        this.getFramework();
                    })
                }
                this.setState({
                    fieldName:this.props.editTemplateItem.fieldName,
                    fieldType:this.props.editTemplateItem.fieldType,
                    fieldTypeArr:fieldTypeArr,
                    placeholderValue:this.props.editTemplateItem.placeholderValue,
                    dropdownValues:dropdownValues,
                    canBeDeleted:this.props.editTemplateItem.canBeDeleted,
                    notRequiredOption_NR:this.props.editTemplateItem.isNotReqSelected,
                    isMandatorySelected:this.props.editTemplateItem.isMandatorySelected,
                    isUsedForExec:this.props.editTemplateItem.isUsedForExec,
                    userOnlyField:this.props.editTemplateItem.userOnlyField ?? "N",
                    observationHeading:this.props.editTemplateItem.observationHeading,
                    observationHeadingFormat:this.props.editTemplateItem.observationHeadingFormat ?? {bold:false,italic:false,underline:false},
                    showFieldHeading:this.props.editTemplateItem.showFieldHeading,
                    executiveSummary:this.props.editTemplateItem.executiveSummary ?? "N",
                    riskLevelExecutiveSummary:this.props.editTemplateItem.riskLevelExecutiveSummary,
                    selectedExecTaskTableFieldId:isEmptyVariable(this.props.editTemplateItem?.execTaskTableFieldId)?"":this.props.editTemplateItem?.execTaskTableFieldId,
                    selectedExecTaskTableFieldName:isEmptyVariable(this.props.editTemplateItem?.execTaskTableFieldName)?"":this.props.editTemplateItem?.execTaskTableFieldName,
                    isDecimalAllowed:isEmptyVariable(this.props.editTemplateItem?.isDecimalAllowed)?"N":this.props.editTemplateItem?.isDecimalAllowed,
                    selectedMaximumScore:this.props.editTemplateItem?.maximumScore ?? maximumScorePlaceholderText,
                    selectedMaximumWeight:this.props.editTemplateItem?.maximumWeight,
                    selectedDecimalValue:isEmptyVariable(this.props.editTemplateItem?.decimalValue)?"":this.props.editTemplateItem?.decimalValue,
                    hasTaskTemplateScore:hasTaskTemplateScore,
                    showDescription:this.props.editTemplateItem?.showDescription,
                    descriptions:this.props.editTemplateItem?.descriptions ?? {},
                    showDescriptionSeparator:this.props.editTemplateItem?.showDescriptionSeparator ?? "N",
                    descriptionSeparator:this.props.editTemplateItem?.descriptionSeparator ?? "",
                    showOnlyDescription:this.props.editTemplateItem?.showOnlyDescription ?? "N",
                    selectedMasterType:this.props.editTemplateItem?.masterType ?? masterTypePlaceholderText,
                    masterSelectionType:this.props.editTemplateItem?.masterSelectionType ?? "",
                    masterNameOrder:this.props.editTemplateItem?.masterNameOrder ?? "",
                    masterShortNameOrder:this.props.editTemplateItem?.masterShortNameOrder ?? "",
                    masterDescriptionOrder:this.props.editTemplateItem?.masterDescriptionOrder ?? "",
                    masterShowEmployeeTitle:"Y",
                    masterShowEmployeeName:this.props.editTemplateItem?.masterShowEmployeeName ?? "N",
                    masterShowEmployeeDesignation:this.props.editTemplateItem?.masterShowEmployeeDesignation ?? "N",
                    masterShowDisplaySeparator:this.props.editTemplateItem?.masterShowDisplaySeparator ?? "N",
                    masterDisplaySeparator:this.props.editTemplateItem?.masterDisplaySeparator ?? "",
                    masterRemarksType:this.props.editTemplateItem?.masterRemarksType ?? "",
                    masterReportNameFormat:this.props.editTemplateItem?.masterReportNameFormat ?? {bold:false,italic:false,underline:false},
                    masterReportShortNameFormat:this.props.editTemplateItem?.masterReportShortNameFormat ?? {bold:false,italic:false,underline:false},
                    masterReportDescriptionFormat:this.props.editTemplateItem?.masterReportDescriptionFormat ?? {bold:false,italic:false,underline:false},
                    masterReportTitleFormat:this.props.editTemplateItem?.masterReportTitleFormat ?? {bold:false,italic:false,underline:false},
                    masterReportEmployeeNameFormat:this.props.editTemplateItem?.masterReportEmployeeNameFormat ?? {bold:false,italic:false,underline:false},
                    masterReportDesignationFormat:this.props.editTemplateItem?.masterReportDesignationFormat ?? {bold:false,italic:false,underline:false},
                },() => {
                    if(this.state.fieldType === TemplateConstants.FIELD_TYPE_SCORE && 
                        !isEmptyVariable(this.state.selectedDecimalValue)){
                        this.generateScores();
                    }
                })
            }else{
                let fieldTypePlaceholder = fieldTypePlaceholderText;
                // if(this.props.isFieldTypeAddedinDD && !isEmptyVariable(this.props.addfieldTypePlaceholder)){
                //     fieldTypePlaceholder = this.props.addfieldTypePlaceholder;
                // }
                // For Execution Templates, set the hasTaskTemplateScore flag from props.
                if(this.props.templateType === TemplateConstants.TEMPLATE_TYPE_EX_TASK){
                    hasTaskTemplateScore = this.props.hasTaskTemplateScore;
                }
                this.setState({
                    fieldName:"",
                    fieldType: this.props.defaultFieldType || fieldTypePlaceholder,
                    fieldTypeArr:fieldTypeArr,
                    placeholderValue:"",
                    dropdownValues:[],
                    notRequiredOption_NR:"Y",
                    isMandatorySelected:"N",
                    isUsedForExec:"N",
                    userOnlyField:"N",
                    observationHeading:"N",
                    observationHeadingFormat:{bold:false,italic:false,underline:false},
                    showFieldHeading:"N",
                    executiveSummary:"N",
                    riskLevelExecutiveSummary:"N",
                    canBeDeleted:"Y",
                    selectedMaximumScore:maximumScorePlaceholderText,
                    selectedMaximumWeight:maximumWeightPlaceholderText,
                    selectedDecimalValue:"",
                    isDecimalAllowed:"N",
                    hasTaskTemplateScore:hasTaskTemplateScore,
                    descriptions:{},
                    selectedFrameworkType:frameworkTypePlaceholderText,
                    selectedMasterType:masterTypePlaceholderText,
                    masterSelectionType:"",
                    masterNameOrder:"1",
                    masterShortNameOrder:"",
                    masterDescriptionOrder:"",
                    masterShowEmployeeTitle:"Y",
                    masterShowEmployeeName:"N",
                    masterShowEmployeeDesignation:"N",
                    masterShowDisplaySeparator:"N",
                    masterDisplaySeparator:"",
                    masterRemarksType:"",
                    masterReportNameFormat:{bold:false,italic:false,underline:false},
                    masterReportShortNameFormat:{bold:false,italic:false,underline:false},
                    masterReportDescriptionFormat:{bold:false,italic:false,underline:false},
                    masterReportTitleFormat:{bold:false,italic:false,underline:false},
                    masterReportEmployeeNameFormat:{bold:false,italic:false,underline:false},
                    masterReportDesignationFormat:{bold:false,italic:false,underline:false},
                    showDescriptionSeparator:"N",
                    descriptionSeparator:"",
                    showOnlyDescription:"N",
                })
            }

            if(!hasFeatureAccess(Constants.FEATURE_INTERNAL_FRAMEWORK)){
                frameworkTypeArr = frameworkTypeArr.filter(item => item.value !== "Internal");
                this.setState({
                    frameworkTypeArr:frameworkTypeArr
                })
            }
        }
    }

    // Handles input changes for text fields and updates state.
    handleChange = (e) => {
        const { name, value } = e.target;
        let FormErrorsTemp = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            if(name === "fieldName"){
                FormErrorsTemp['fieldName'] = "";
            }
            if(name === "placeholderValue"){
                FormErrorsTemp['placeholderValue'] = "";
            }
        }
        this.setState({
            [name]: value,
            formErrors: FormErrorsTemp
        });
    }

    // Restricts the description separator input to non-alphanumeric characters only.
    handleDescriptionSeparatorChange = (e) => {
        const oldValue = this.state.descriptionSeparator;
        let value = e.target.value.replace(/[a-zA-Z0-9]/g, "");
        // Entering a lone opening bracket auto-completes it to its open/closing pair. Only do this
        // when a character was just inserted (value grew) - otherwise deleting the closing bracket
        // (which leaves the same lone-opening-bracket value) would just add it right back.
        const bracketPairs = {"(":")", "[":"]", "{":"}"};
        if(bracketPairs[value] && value.length > oldValue.length){
            value = value + bracketPairs[value];
        }
        let FormErrorsTemp = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['descriptionSeparator'] = "";
        }
        this.setState({
            descriptionSeparator: value,
            formErrors: FormErrorsTemp
        });
    }

    // Handles selection for decimal value radio buttons.
    handleSelection = (e) =>{
        this.setState({
            selectedDecimalValue:e.target.name
        }, () => {
            this.generateScores();
        })
    }

    handleAddDescriptionClick = () => {
        this.setState({
            showDescriptionDialog:true
        })
    }

    handleDescriptionDialogClose = () => {
        this.setState({
            showDescriptionDialog:false
        })
    }

    handleSaveDescription = (descriptions) => {
        this.setState({
            descriptions:descriptions,
            showDescriptionDialog:false
        })
    }

    handleObservationHeadingCheck = (e) => {
         const { name, checked } = e.target;
        this.setState((prevState) => ({
            observationHeadingFormat: {
                ...prevState.observationHeadingFormat,
                [name]: checked
            }
        }));
    }

    handleCheckRadio = () => {

    }

    // Handles checkbox changes for various boolean options.
    handleCheck = (e) =>{
        let isChecked = e.target.checked;
        let name = e.target.name;
        if(name === "observationHeading" && !isChecked){
            this.setState({
                observationHeadingFormat:{bold:false,italic:false,underline:false}
            })
        }
        // "Show Description Also Separator" and "Show Only Description" are mutually exclusive.
        if(isChecked && name === "showDescriptionSeparator"){
            this.setState({
                showOnlyDescription:"N",
            })
        }
        if(isChecked && name === "showOnlyDescription"){
            let FormErrorsTemp = this.state.formErrors;
            FormErrorsTemp['descriptionSeparator'] = "";
            this.setState({
                showDescriptionSeparator:"N",
                descriptionSeparator:"",
                formErrors:FormErrorsTemp
            })
        }
        // Sets the corresponding state value to "Y" if checked, "N" if unchecked.
        if(isChecked){
            this.setState({
                [name]:"Y",
            })
        }
        // If the "isDecimalAllowed" checkbox is unchecked, also resets selectedDecimalValue to "N".
        else{
            if(name === "isDecimalAllowed"){
                this.setState({
                    selectedDecimalValue:"N",
                })
            }
            if(name === "showDescriptionSeparator"){
                let FormErrorsTemp = this.state.formErrors;
                FormErrorsTemp['descriptionSeparator'] = "";
                this.setState({
                    descriptionSeparator:"",
                    formErrors:FormErrorsTemp
                })
            }
            this.setState({
                [name]:"N",
            })
        }
    }

    // Handles selection from the field type dropdown.
    fieldTypeDropdownClick = (item) => {
        // if(item.value == TemplateConstants.FIELD_TYPE_FRAMEWORK){
        //     this.setState({
        //         isDisplayFramework:true
        //     })
        // }
        // If "Score" is selected, resets maximum score, disables decimal, and clears decimal value.
        if(item.value === TemplateConstants.FIELD_TYPE_SCORE){
            this.setState({
                selectedMaximumScore:maximumScorePlaceholderText,
                isDecimalAllowed:"N",
                selectedDecimalValue:"",
                isMandatorySelected:this.state.hasTaskTemplateScore?"Y":"N",
            });
        }
        let FormErrorsTemp = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['fieldType'] = "";
        }
        // Updates the field type and sets the "Not Required" option to "N" for Weighted/Maximum Score fields, otherwise "Y".
        this.setState({
            fieldType:item.value,
            formErrors:FormErrorsTemp,
            notRequiredOption_NR:(item.value == TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE || item.value == TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE)?"N":"Y" 
        })
    }

    frameworkTypeDropdownClick = (item) => {
        let FormErrorsTemp = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['frameworkType'] = "";
        }
        this.setState({
            selectedFrameworkType:item.value,
            selectedFrameworkObj:[],
            formErrors:FormErrorsTemp
        },() => {
            this.getFramework();
        })
    }

    masterTypeDropdownClick = (item) => {
        let FormErrorsTemp = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['masterType'] = "";
        }
        this.setState({
            selectedMasterType:item.value,
            formErrors:FormErrorsTemp
        });
    }

    // For the Employee master type, the field labels change to Title/Name/Designation
    // and are toggled with checkboxes instead of typed order numbers.
    isEmployeeMasterType = () => {
        return this.state.selectedMasterType === TemplateConstants.MASTER_TYPE_EMPLOYEE;
    }

    // Toggles the Name/Designation checkboxes for the Employee master type (plain show/hide flags,
    // not an order - Title is always shown and isn't backed by any state since it can't be unchecked).
    handleMasterEmployeeFieldCheck = (e) => {
        const { name, checked } = e.target;
        let stateUpdate = {
            [name]: checked ? "Y" : "N"
        };
        // "Display Separator (For Designation)" only makes sense once Designation is shown.
        if(name === "masterShowEmployeeDesignation" && !checked){
            stateUpdate.masterShowDisplaySeparator = "N";
            stateUpdate.masterDisplaySeparator = "";
        }
        this.setState(stateUpdate);
    }

    handleMasterSelectionTypeChange = (e) => {
        let FormErrorsTemp = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['masterSelectionType'] = "";
        }
        this.setState({
            masterSelectionType:e.target.name,
            // Clear Remarks on any Single-Select/Multi-Select change; no option is pre-selected.
            masterRemarksType:"",
            formErrors:FormErrorsTemp
        })
    }

    handleMasterRemarksTypeChange = (e) => {
        let FormErrorsTemp = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['masterRemarksType'] = "";
        }
        this.setState({
            masterRemarksType:e.target.name,
            formErrors:FormErrorsTemp
        })
    }

    // Restricts the master order inputs (Name/Short Name/Description) to 1, 2, or 3 only.
    handleMasterOrderChange = (e) => {
        const { name, value } = e.target;
        const numericValue = value.replace(/[^1-3]/g, "");
        let FormErrorsTemp = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['masterOrder'] = "";
        }
        this.setState({
            [name]: numericValue,
            formErrors: FormErrorsTemp
        });
    }

    handleMasterDisplaySeparatorChange = (e) => {
        const oldValue = this.state.masterDisplaySeparator;
        let value = e.target.value.replace(/[a-zA-Z0-9]/g, "");
        // Entering a lone opening bracket auto-completes it to its open/closing pair. Only do this
        // when a character was just inserted (value grew) - otherwise deleting the closing bracket
        // (which leaves the same lone-opening-bracket value) would just add it right back.
        const bracketPairs = {"(":")", "[":"]", "{":"}"};
        if(bracketPairs[value] && value.length > oldValue.length){
            value = value + bracketPairs[value];
        }
        let FormErrorsTemp = this.state.formErrors;
        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['masterDisplaySeparator'] = "";
        }
        this.setState({
            masterDisplaySeparator: value,
            formErrors: FormErrorsTemp
        });
    }

    // Toggles bold/italic/underline for one of the Master field's Download Report format objects.
    handleMasterFormatCheck = (formatKey, e) => {
        const { name, checked } = e.target;
        this.setState(prevState => ({
            [formatKey]: {
                ...prevState[formatKey],
                [name]: checked
            }
        }));
    }

    renderMasterFormatRow = (label, formatKey) => {
        const format = this.state[formatKey];
        return (
            <div className='d-flex align-items-center mb-2'>
                <p className='m-b-0' style={{minWidth:100}}>{label}</p>
                <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0, marginRight: 10 }}>
                    <input
                        type="checkbox"
                        name="bold"
                        id={formatKey+"Bold"}
                        onChange={(e)=>this.handleMasterFormatCheck(formatKey,e)}
                        checked={format.bold}
                    />
                    <label for={formatKey+"Bold"}>Bold</label>
                </FilterCheckBox>
                <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0, marginRight: 10 }}>
                    <input
                        type="checkbox"
                        name="italic"
                        id={formatKey+"Italic"}
                        onChange={(e)=>this.handleMasterFormatCheck(formatKey,e)}
                        checked={format.italic}
                    />
                    <label for={formatKey+"Italic"}>Italic</label>
                </FilterCheckBox>
                <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0 }}>
                    <input
                        type="checkbox"
                        name="underline"
                        id={formatKey+"Underline"}
                        onChange={(e)=>this.handleMasterFormatCheck(formatKey,e)}
                        checked={format.underline}
                    />
                    <label for={formatKey+"Underline"}>Underline</label>
                </FilterCheckBox>
            </div>
        );
    }

    handleFrameworkDialogClose = (reloadFlag, selectedFrameworkObj) => {
        if(reloadFlag === true){
            this.setState({
                selectedFrameworkObj:selectedFrameworkObj
            })
        }
        this.setState({
            showFramework:false
        })
    }

    // Handles selection from the execute task table dropdown.
    execTaskTableDropdownClick = (item) => {
        this.setState({
            selectedExecTaskTableFieldName:item.fieldName,
            selectedExecTaskTableFieldId:item.fieldId,
        })
    }

    // Handles selection from the maximum score dropdown.
    maxScoreDropdownClick = (item) => {
        this.setState({
            selectedMaximumScore:item.label
        },() => {
            if(!isEmptyVariable(this.state.selectedDecimalValue)){
                this.generateScores();
            }
        })
    }

    // Handles selection from the weighted score dropdown.
    weightedScoreDropdownClick = (item) => {
        this.setState({
            selectedMaximumWeight:item.label
        })
    }

    // Opens the dialog to add or edit dropdown values.
    handleAddEditDDValuesClick = () => {
        if(!isEmptyArray(this.state.dropdownValues)){
            this.setState({
                showCreateDDValueDialog:true,
                isDDValuesEdit:true,
            });
        }else{
            
            this.setState({
                showCreateDDValueDialog:true,
                isDDValuesEdit:false,
            });
        }
    }

    handleAddFramework = () => {
        this.setState({
            showFramework:true
        })
    }

    // Handles closing the add/edit dropdown values dialog and updates state.
    handleCreateDDValueDialogClose = (typeDDValueArr) => {
        if(!isEmptyArray(typeDDValueArr)){
            this.setState({
                showCreateDDValueDialog:false,
                isDDValuesEdit:false,
                dropdownValues:typeDDValueArr
            });
        }else{
        
            this.setState({
                showCreateDDValueDialog:false,
                isDDValuesEdit:false,
            });
        }
    }

    // Checks if any field values have been updated compared to previous props.
    checkForUpdates = () => {
        // if(fieldStatus === "Updated"){
        //     return true;
        // }
        if(this.state.fieldName !== this.props.editTemplateItem_prev?.fieldName){
            return true;
        }
        
        if(this.state.fieldType !== this.props.editTemplateItem_prev?.fieldType){
            return true;
        }

        if(this.state.placeholderValue !== this.props.editTemplateItem_prev?.placeholderValue){
            return true;
        }

        if(this.state.notRequiredOption_NR !== this.props.editTemplateItem_prev?.isNotReqSelected){
            return true;
        }

        if(this.state.isMandatorySelected !== this.props.editTemplateItem_prev?.isMandatorySelected){
            return true;
        }

        if(this.state.isUsedForExec !== this.props.editTemplateItem_prev?.isUsedForExec){
            return true;
        }

        if(this.state.selectedMaximumScore !== this.props.editTemplateItem_prev?.maximumScore){
            return true;
        }
        if(this.state.selectedMaximumWeight !== this.props.editTemplateItem?.maximumWeight){
            return true;
        }
        if(this.state.isDecimalAllowed !== this.props.editTemplateItem_prev?.isDecimalAllowed){
            return true;
        }
        if(this.props.templateType === TemplateConstants.TEMPLATE_TYPE_OBSERVATION &&
        this.state.observationHeading !== this.props.editTemplateItem_prev?.observationHeading){
        }

        if(this.props.templateType === TemplateConstants.TEMPLATE_TYPE_OBSERVATION &&
        this.state.observationHeadingFormat !== this.props.editTemplateItem_prev?.observationHeadingFormat){
            return true;
        }
        if(this.props.templateType === TemplateConstants.TEMPLATE_TYPE_OBSERVATION &&
        this.state.showFieldHeading !== this.props.editTemplateItem_prev?.showFieldHeading){
            return true;
        }

        if(this.props.templateType === TemplateConstants.TEMPLATE_TYPE_OBSERVATION &&
        this.state.executiveSummary !== this.props.editTemplateItem_prev?.executiveSummary){
            return true;
        }
        if(this.props.templateType === TemplateConstants.TEMPLATE_TYPE_OBSERVATION &&
        this.state.riskLevelExecutiveSummary !== this.props.editTemplateItem_prev?.riskLevelExecutiveSummary){
            return true;
        }

        if(this.state.selectedDecimalValue !== this.props.editTemplateItem_prev?.decimalValue){
            return true;
        }
        if(this.state.descriptions !== this.props.editTemplateItem_prev?.descriptions){
            return true;
        }
        if(this.state.showDescriptionSeparator !== this.props.editTemplateItem_prev?.showDescriptionSeparator){
            return true;
        }
        if(this.state.descriptionSeparator !== this.props.editTemplateItem_prev?.descriptionSeparator){
            return true;
        }
        if(this.state.showOnlyDescription !== this.props.editTemplateItem_prev?.showOnlyDescription){
            return true;
        }
        // dropdownValues (for select-type fields)
        if((this.state.fieldType === TemplateConstants.FIELD_TYPE_SINGLE_SELECT ||
            this.state.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT ||
            this.state.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI || 
            this.state.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN ||
            this.state.fieldType === TemplateConstants.FIELD_TYPE_YES_NO ||
            this.state.fieldType === TemplateConstants.FIELD_TYPE_ISO) &&
            JSON.stringify(this.state.dropdownValues) !== JSON.stringify(this.props.editTemplateItem_prev?.dropdownValues)){
            return true;
        }
        // selectedExecTaskTableFieldId (for EX_TASK Table fields)
        if(this.state.fieldType === TemplateConstants.FIELD_TYPE_TABLE &&
        this.props.templateType === TemplateConstants.TEMPLATE_TYPE_EX_TASK &&
        this.state.selectedExecTaskTableFieldId !== this.props.editTemplateItem_prev?.selectedExecTaskTableFieldId){
            return true;
        }
        if(this.state.fieldType === TemplateConstants.FIELD_TYPE_FRAMEWORK){
            if(this.state.selectedFrameworkType !== this.props.editTemplateItem_prev?.frameworkType){
                return true;
            }
            if(this.state.fieldType === TemplateConstants.FIELD_TYPE_FRAMEWORK &&
            this.state.selectedFrameworkObj !== JSON.parse(this.props.editTemplateItem.frameworkList)){
                return true;
            }
        }
        if(this.state.fieldType === TemplateConstants.FIELD_TYPE_MASTER){
            if(this.state.selectedMasterType !== this.props.editTemplateItem_prev?.masterType){
                return true;
            }
            if(this.state.masterSelectionType !== this.props.editTemplateItem_prev?.masterSelectionType){
                return true;
            }
            if(this.state.masterNameOrder !== this.props.editTemplateItem_prev?.masterNameOrder){
                return true;
            }
            if(this.state.masterShortNameOrder !== this.props.editTemplateItem_prev?.masterShortNameOrder){
                return true;
            }
            if(this.state.masterDescriptionOrder !== this.props.editTemplateItem_prev?.masterDescriptionOrder){
                return true;
            }
            if(this.state.masterShowEmployeeName !== this.props.editTemplateItem_prev?.masterShowEmployeeName){
                return true;
            }
            if(this.state.masterShowEmployeeDesignation !== this.props.editTemplateItem_prev?.masterShowEmployeeDesignation){
                return true;
            }
            if(this.state.masterShowDisplaySeparator !== this.props.editTemplateItem_prev?.masterShowDisplaySeparator){
                return true;
            }
            if(this.state.masterDisplaySeparator !== this.props.editTemplateItem_prev?.masterDisplaySeparator){
                return true;
            }
            if(this.state.masterRemarksType !== this.props.editTemplateItem_prev?.masterRemarksType){
                return true;
            }
            if(JSON.stringify(this.state.masterReportNameFormat) !== JSON.stringify(this.props.editTemplateItem_prev?.masterReportNameFormat)){
                return true;
            }
            if(JSON.stringify(this.state.masterReportShortNameFormat) !== JSON.stringify(this.props.editTemplateItem_prev?.masterReportShortNameFormat)){
                return true;
            }
            if(JSON.stringify(this.state.masterReportDescriptionFormat) !== JSON.stringify(this.props.editTemplateItem_prev?.masterReportDescriptionFormat)){
                return true;
            }
            if(JSON.stringify(this.state.masterReportTitleFormat) !== JSON.stringify(this.props.editTemplateItem_prev?.masterReportTitleFormat)){
                return true;
            }
            if(JSON.stringify(this.state.masterReportEmployeeNameFormat) !== JSON.stringify(this.props.editTemplateItem_prev?.masterReportEmployeeNameFormat)){
                return true;
            }
            if(JSON.stringify(this.state.masterReportDesignationFormat) !== JSON.stringify(this.props.editTemplateItem_prev?.masterReportDesignationFormat)){
                return true;
            }
        }
        return false;
    }

    getFramework = () => {
        this.setState({
            showLoader:true,
        });
        let url = "";
        let postParam = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            status:"active"
        }
        if(this.state.selectedFrameworkType == "Internal"){
            url = Constants.GetInternalRootFramework;
        }else{
            url = Constants.GetRootFramework;
            postParam.clientId = this.props.clientId;
        }
        fetch(url, {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams(postParam)
        })
        .then(res => res.json())
        .then(res => {
            let frameworks = [];
            let frameworkArr = [];
            if(handleTokenExpiry(res.responseCode)) return;
            else if(res.responseCode === Constants.CODE_SUCCESS){
                frameworks = res.data.result;
                frameworkArr = frameworks.map(item => {
                    return {
                        frameworkId: item.frameworkId,
                        frameworkName: item.frameworkName
                    }
                })
            }

            this.setState({
                frameworkArr: frameworkArr
            });
        })
    }

    // Validates form fields and triggers the creation or update of a field.
    handleCreateField = () =>{
        let isError = false;
        let duplicateFlag = false;
        let FormErrorsTemp = {};
        this.setState({
            submitClickedAtleastOnce:true
        });
        // Field name is required.
        if(isEmptyVariable(this.state.fieldName)){
            isError = true;
            FormErrorsTemp['fieldName'] = "Please enter Field name";
        }
        // Field name must be alphanumeric.
        if(!isEmptyVariable(this.state.fieldName)){
            if(!isAlphaNumericCharacter(this.state.fieldName)){
                isError = true;
                FormErrorsTemp['fieldName'] = "Field name should be Alphanumeric";
            }
            // Field name must not duplicate an existing field name (excluding this field's own original name when editing).
            let isUnchangedFieldName = this.props.isEdit &&
                this.state.fieldName.trim() === this.props.editTemplateItem?.fieldName?.trim();
            duplicateFlag = !isUnchangedFieldName && this.props.fieldNameArray.includes(this.state.fieldName.trim());
            if(duplicateFlag){
                isError = true;
                FormErrorsTemp['fieldName'] = "Field name cannot be same";
            }
        }
        // Field type is required.
        if(isEmptyVariable(this.state.fieldType) || this.state.fieldType === fieldTypePlaceholderText){
            isError = true;
            FormErrorsTemp['fieldType'] = "Please select Field type";
        }
        // Placeholder value is required (except for Table field type)
        if(isEmptyVariable(this.state.placeholderValue) && 
            this.state.fieldType !== TemplateConstants.FIELD_TYPE_TABLE){
            isError = true;
            FormErrorsTemp['placeholderValue'] = "Please enter Placeholder value";
        }
        //  Placeholder must be alphanumeric.
        if(!isEmptyVariable(this.state.placeholderValue)){
            if(!isAlphaNumericCharacter(this.state.placeholderValue)){
                isError = true;
                FormErrorsTemp['placeholderValue'] = "Placeholder should be Alphanumeric";
            }
        }
        // Dropdown values are required for select-type fields (unless editing from Risk Master).
        if(((this.state.fieldType === TemplateConstants.FIELD_TYPE_SINGLE_SELECT ||
            this.state.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT ||
            this.state.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN || 
            this.state.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI ||
            this.state.fieldType === TemplateConstants.FIELD_TYPE_ISO) && 
            isEmptyArray(this.state.dropdownValues) &&
            !this.props.editTemplateItem.isFromRiskMaster) &&
            this.props.editTemplateItem?.isResponsibilityField !== "Y"){

            isError = true;
            FormErrorsTemp['fieldType'] = "Please enter Dropdown values";
        }
        // For Single-select/Multi-select/Dropdown Multiselect fields with separator enabled, a separator value must be entered.
        if((this.state.fieldType === TemplateConstants.FIELD_TYPE_SINGLE_SELECT ||
            this.state.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT ||
            this.state.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI) &&
            this.state.showDescriptionSeparator === "Y" &&
            isEmptyVariable(this.state.descriptionSeparator)){
            isError = true;
            FormErrorsTemp['descriptionSeparator'] = "Please enter separator";
        }
        // For Execution Templates Table fields, a linked assigned task must be selected.
        if(this.state.fieldType === TemplateConstants.FIELD_TYPE_TABLE &&
        this.props.templateType === TemplateConstants.TEMPLATE_TYPE_EX_TASK &&
        isEmptyVariable(this.state.selectedExecTaskTableFieldId)){
            isError = true;
            FormErrorsTemp['execTaskTableField'] = "Please select task table";
        }

        // For Score/Maximum Score fields, a maximum score must be selected.
        if(((this.state.fieldType === TemplateConstants.FIELD_TYPE_SCORE && !this.state.hasTaskTemplateScore) ||
            this.state.fieldType === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE) &&
            this.state.selectedMaximumScore === maximumScorePlaceholderText){
                isError = true;
                FormErrorsTemp['score'] = "Please select maximum score";
        }

        // For Score fields with decimal allowed, a decimal value must be selected.
        if(this.state.fieldType === TemplateConstants.FIELD_TYPE_SCORE &&
            this.state.isDecimalAllowed === "Y" && 
            isEmptyVariable(this.state.selectedDecimalValue)){
                isError = true;
                FormErrorsTemp['decimalValue'] = "Please select decimal value";
        }
        // For Weighted Score fields, a maximum weight must be selected.
        if(this.state.fieldType === TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE &&
            this.state.selectedMaximumWeight === maximumWeightPlaceholderText){
            isError = true;
            FormErrorsTemp['maximumWeight'] = "Please select weighted score"
        }
        if(this.state.fieldType === TemplateConstants.FIELD_TYPE_FRAMEWORK){
            if(isEmptyVariable(this.state.selectedFrameworkType) || 
            this.state.selectedFrameworkType === frameworkTypePlaceholderText){
                isError = true;
                FormErrorsTemp['frameworkType'] = "Please select Framework Type"
            }
            if(isEmptyArray(this.state.selectedFrameworkObj)){
                isError = true;
                FormErrorsTemp['frameworkType'] = "Please select Framework";
            }
        }
        if(this.state.fieldType === TemplateConstants.FIELD_TYPE_MASTER){
            if(isEmptyVariable(this.state.selectedMasterType) ||
            this.state.selectedMasterType === masterTypePlaceholderText){
                isError = true;
                FormErrorsTemp['masterType'] = "Please select Master Type";
            }
            if(isEmptyVariable(this.state.masterSelectionType)){
                isError = true;
                FormErrorsTemp['masterSelectionType'] = "Please select Single-Select or Multi-Select";
            }
            if(this.state.masterShowDisplaySeparator === "Y" &&
            isEmptyVariable(this.state.masterDisplaySeparator)){
                isError = true;
                FormErrorsTemp['masterDisplaySeparator'] = "Please enter separator";
            }
        }
        // If any validation fails, sets error messages in state and displays them.
        if(isError){
            this.setState({
                formErrors:FormErrorsTemp,
                showLoader:false
            });

            setTimeout(() => {
                this.setState({
                    formErrors:{},
                });
            },Constants.WRNG_MSG_TIMEOUT);

        }
        // If validation passes, constructs the field object with all relevant properties and
        // calls the parent handler to save or update the field.
        else{
            let fieldObj = {};
            try{
                fieldObj = JSON.parse(JSON.stringify(this.props.editTemplateItem));
            }catch(e){
                fieldObj = {};
            }
        
            fieldObj.fieldName =this.state.fieldName;
            fieldObj.fieldType =this.state.fieldType;
            fieldObj.isNotReqSelected = this.state.notRequiredOption_NR;
            fieldObj.isUsedForExec = this.state.isUsedForExec;
            fieldObj.showDescription = this.state.showDescription;
            fieldObj.canBeDeleted = this.state.canBeDeleted;

            // For Single-select/Multi-select/Dropdown Multiselect fields, persist description display options.
            if(this.state.fieldType === TemplateConstants.FIELD_TYPE_SINGLE_SELECT ||
                this.state.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT ||
                this.state.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI){
                fieldObj.showDescriptionSeparator = this.state.showDescriptionSeparator;
                fieldObj.descriptionSeparator = this.state.showDescriptionSeparator === "Y"?this.state.descriptionSeparator:"";
                fieldObj.showOnlyDescription = this.state.showOnlyDescription;
            }

            //if Execution Template table fields, add linked assigned task field ID and name.
            if(this.state.fieldType === TemplateConstants.FIELD_TYPE_TABLE &&
            this.props.templateType === TemplateConstants.TEMPLATE_TYPE_EX_TASK){
                fieldObj.execTaskTableFieldId = this.state.selectedExecTaskTableFieldId;
                fieldObj.execTaskTableFieldName = this.state.selectedExecTaskTableFieldName;
            }
            
            // For Execution templates with YES_NO, NUMERIC, or VALUE_ADDITION fields, set isNotReqSelected to "N" (not required).
            if((this.state.fieldType === TemplateConstants.FIELD_TYPE_YES_NO ||
                this.state.fieldType === TemplateConstants.FIELD_TYPE_NUMERIC ||
                this.state.fieldType === TemplateConstants.FIELD_TYPE_VALUE_ADDITION) &&
                this.props.templateType === TemplateConstants.TEMPLATE_TYPE_EX_TASK){
                fieldObj.isNotReqSelected = "N";
            }

            // For all fields except Table in AUDITEE_COMMENT templates, set isMandatorySelected based on state.
            if(this.state.fieldType !== TemplateConstants.FIELD_TYPE_TABLE ||
                this.props.templateType !== TemplateConstants.TEMPLATE_TYPE_AUDITEE_COMMENT){
                    fieldObj.isMandatorySelected = this.state.isMandatorySelected;
            }
            if(this.props.templateType === TemplateConstants.TEMPLATE_TYPE_AUDITEE_COMMENT){
                fieldObj.userOnlyField = this.state.userOnlyField;
            }
            // For OBSERVATION templates with TEXT fields, set executiveSummary and riskLevelExecutiveSummary if applicable.
            if(this.state.fieldType === TemplateConstants.FIELD_TYPE_TEXT &&
                this.props.templateType === TemplateConstants.TEMPLATE_TYPE_OBSERVATION){
                fieldObj.executiveSummary= this.state.executiveSummary;
                if(this.props?.assignRisk === "Y"){
                    fieldObj.riskLevelExecutiveSummary= this.state.riskLevelExecutiveSummary;
                }
            }
            if(this.props.templateType === TemplateConstants.TEMPLATE_TYPE_OBSERVATION){
                fieldObj.observationHeading = this.state.observationHeading;
                if(this.state.observationHeading === "Y"){
                    fieldObj.observationHeadingFormat = this.state.observationHeadingFormat;
                }
                fieldObj.showFieldHeading = this.state.showFieldHeading;
            }

            if(this.state.fieldType === TemplateConstants.FIELD_TYPE_FRAMEWORK){
                fieldObj.frameworkType = this.state.selectedFrameworkType;
                fieldObj.frameworkList = this.state.selectedFrameworkObj;
            }
            if(this.state.fieldType === TemplateConstants.FIELD_TYPE_MASTER){
                fieldObj.masterType = this.state.selectedMasterType;
                fieldObj.masterSelectionType = this.state.masterSelectionType;
                // Employee's Title/Name/Designation are plain show/hide flags, not an orderable sequence,
                // so they use their own fields instead of the Designation master's order fields.
                if(this.isEmployeeMasterType()){
                    fieldObj.masterShowEmployeeTitle = this.state.masterShowEmployeeTitle;
                    fieldObj.masterShowEmployeeName = this.state.masterShowEmployeeName;
                    fieldObj.masterShowEmployeeDesignation = this.state.masterShowEmployeeDesignation;
                    delete fieldObj.masterNameOrder;
                    delete fieldObj.masterShortNameOrder;
                    delete fieldObj.masterDescriptionOrder;
                }else{
                    fieldObj.masterNameOrder = this.state.masterNameOrder;
                    fieldObj.masterShortNameOrder = this.state.masterShortNameOrder;
                    fieldObj.masterDescriptionOrder = this.state.masterDescriptionOrder;
                    delete fieldObj.masterShowEmployeeTitle;
                    delete fieldObj.masterShowEmployeeName;
                    delete fieldObj.masterShowEmployeeDesignation;
                }
                fieldObj.masterShowDisplaySeparator = this.state.masterShowDisplaySeparator;
                fieldObj.masterDisplaySeparator = this.state.masterShowDisplaySeparator === "Y" ? this.state.masterDisplaySeparator : "";
                fieldObj.masterRemarksType = this.state.masterRemarksType;
                // Employee uses its own Title/Name/Designation format keys instead of the Designation master's Name/Short Name/Description keys.
                if(!this.isEmployeeMasterType()){
                    fieldObj.masterReportNameFormat = this.state.masterReportNameFormat;
                    fieldObj.masterReportShortNameFormat = this.state.masterReportShortNameFormat;
                    fieldObj.masterReportDescriptionFormat = this.state.masterReportDescriptionFormat;
                    delete fieldObj.masterReportTitleFormat;
                    delete fieldObj.masterReportEmployeeNameFormat;
                    delete fieldObj.masterReportDesignationFormat;
                }else{
                    fieldObj.masterReportTitleFormat = this.state.masterReportTitleFormat;
                    fieldObj.masterReportEmployeeNameFormat = this.state.masterReportEmployeeNameFormat;
                    fieldObj.masterReportDesignationFormat = this.state.masterReportDesignationFormat;
                    delete fieldObj.masterReportNameFormat;
                    delete fieldObj.masterReportShortNameFormat;
                    delete fieldObj.masterReportDescriptionFormat;
                }
            }
            // For edit mode, update fieldStatus_new based on whether any field values have changed.
            if(this.props.isEdit){
                //check anything is updated
                let updateFlag = this.checkForUpdates();
                if(updateFlag){
                    fieldObj.fieldStatus_new = fieldObj.fieldStatus === "Created"?"Created":"Updated"
                }else{
                    fieldObj.fieldStatus_new = fieldObj.fieldStatus === "Created"?"Created":"Active"
                }
            }else{
                fieldObj.fieldStatus = "Created";
                fieldObj.fieldStatus_new = "Created";
            }

            // For select-type fields, set dropdownValues from state.
            if(this.state.fieldType === TemplateConstants.FIELD_TYPE_SINGLE_SELECT ||
                this.state.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT ||
                this.state.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN ||
                this.state.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI ||
                this.state.fieldType === TemplateConstants.FIELD_TYPE_ISO){
                    
                    fieldObj.dropdownValues = this.state.dropdownValues;
            }
            // For all fields except Table, set placeholderValue from state.
            if(this.state.fieldType !== TemplateConstants.FIELD_TYPE_TABLE){
                fieldObj.placeholderValue = this.state.placeholderValue
            }
            // For YES_NO fields, set dropdownValues to the default YES/NO array.
            if(this.state.fieldType === TemplateConstants.FIELD_TYPE_YES_NO){
                fieldObj.dropdownValues = TemplateConstants.FIELD_TYPE_YES_NO_DD_VALUE_ARR;
            }
            // For OPEN_CLOSED fields, set dropdownValues to the default Open/Closed array.
            if(this.state.fieldType === TemplateConstants.FIELD_TYPE_OPEN_CLOSED){
                fieldObj.dropdownValues = TemplateConstants.FIELD_TYPE_OPEN_CLOSED_DD_VALUE_ARR;
            }
            // For SCORE, WEIGHTED_SCORE, and MAXIMUM_SCORE fields, set their respective properties from state.
            if(this.state.fieldType === TemplateConstants.FIELD_TYPE_SCORE){
                // maximumScore is inherited from the linked task template's Maximum Score field when hasTaskTemplateScore is true.
                if(!this.state.hasTaskTemplateScore){
                    fieldObj.maximumScore = this.state.selectedMaximumScore;
                }
                // Decimal Allowed is independently configurable regardless of hasTaskTemplateScore.
                if(this.state.isDecimalAllowed === "Y"){
                    fieldObj.decimalValue = this.state.selectedDecimalValue;
                    const hasAnyDescription = this.state.descriptions &&
                        Object.values(this.state.descriptions).some((val) => val && val.trim() !== "");
                    if(hasAnyDescription){
                        fieldObj.descriptions = this.state.descriptions;
                    }else{
                        delete fieldObj.descriptions;
                    }
                }else{
                    delete fieldObj.decimalValue;
                    delete fieldObj.descriptions;
                }
                fieldObj.isDecimalAllowed = this.state.isDecimalAllowed;
            }
            if(this.state.fieldType === TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE){
                fieldObj.maximumWeight = this.state.selectedMaximumWeight;
            }
            if(this.state.fieldType === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE){
                fieldObj.maximumScore = this.state.selectedMaximumScore;
            }
            // Calls the parent component's handler to close the dialog and save the field.
            this.props.handleCreateDialogClose(fieldObj);
        }
    }

    // Closes the create/edit field dialog.
    handleCreateDialogClose = () =>{
        this.props.handleCreateDialogClose(false);
    }

    /**
    * Determines whether the "Not Required" option checkbox should be displayed for the field.
    * The option is shown only if:
    * - The field can be deleted (canBeDeleted === "Y")
    * - The template type is TASK, OBSERVATION, or Execution Templates with field type SINGLE_SELECT, MULTI_SELECT, or TABLE
    * - The field is being added to the "Right" position
    * Returns true if all conditions are met, otherwise false.
    */
    getNotRequiredOptionDisplayFlag = () => {
        if(this.state.canBeDeleted === "Y" &&
        (this.props.templateType === TemplateConstants.TEMPLATE_TYPE_TASK ||
        this.props.templateType === TemplateConstants.TEMPLATE_TYPE_OBSERVATION ||
        (
            this.props.templateType === TemplateConstants.TEMPLATE_TYPE_EX_TASK &&
            (
                this.state.fieldType === TemplateConstants.FIELD_TYPE_SINGLE_SELECT ||
                this.state.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT ||
                this.state.fieldType === TemplateConstants.FIELD_TYPE_TABLE ||
                this.state.fieldType === TemplateConstants.FIELD_TYPE_ISO
            )
        )) &&
        this.props.addToPosition === "Right"){
            return true;
        }

        return false;
    }

    generateScores = () => {
        const { selectedMaximumScore, selectedDecimalValue } = this.state;
        let step = 1;
        switch (selectedDecimalValue) {
          case "tenth":
            step = 0.1;
            break;
          case "quarter":
            step = 0.25;
            break;
          case "half":
            step = 0.5;
            break;
          case "any":
            step = 0.01; // show only whole numbers in popup
            break;
          default:
            step = 1;
        }
        // generate all possible values
        let values = [];
        for (let i = 0; i <= selectedMaximumScore; i += step) {
          values.push(Number(i.toFixed(2)));
        }

        // check if more than 9 combinations exist
        const showScoreDescription = values.length <= 9;
        
        // Take Only first 9 values
        values = values.slice(0, 9);
        
        // Build descriptions object with empty strings
        let initialDescriptions = {};
        if (showScoreDescription) {
            values.forEach((v) => {
                initialDescriptions[v] = this.state.descriptions[v] || "";
            });
        }
    
        this.setState({ 
            scores: values, 
            descriptions: initialDescriptions,
            showScoreDescription
        });
    }

    render() {
        return(
            <Modal className="custom-dialog" show={this.props.showCreateDialog} backdrop="static">
                <Modal.Header>
                <h5>{this.props.isEdit?"Edit Field":"Add New Field"}</h5>
                <button 
                    onClick={this.handleCreateDialogClose}
                    type="button" data-dismiss="modal">
                    <span class="material-icons">close</span>
                </button>
            </Modal.Header>
                <hr />
                <div class="modal-body">
                    <div class="addnew-modal-form">
                        <div class="addnew-modal-form-group">
                            <p>Field Name*</p>
                            <input type="text" placeholder="Enter Short Name"
                            name="fieldName" value={this.state.fieldName} onChange={this.handleChange}/>
                            {
                                !isEmptyVariable(this.state.formErrors['fieldName']) &&
                                <span class="cm-error">{this.state.formErrors['fieldName']}</span>
                            }
                        </div>
                        {
                            <div class="addnew-modal-form-group">
                                <p>Field Type*</p>
                                <RegularDropdown 
                                    placeholder={this.state.fieldType}
                                    dropdownArr={this.state.fieldTypeArr}
                                    labelParam="value"
                                    onDropDownItemClick={this.fieldTypeDropdownClick}
                                    // isFocusRequired={true}
                                    defaultPlaceholderDropDown = {fieldTypePlaceholderText}
                                    disabled = {
                                        ((this.state.canBeDeleted  === "N" && this.props.templateType !== TemplateConstants.TEMPLATE_TYPE_GENERAL) ||
                                        this.props.isUsedInTasks ||
                                        (this.props.isEdit && this.props.templateType !== TemplateConstants.TEMPLATE_TYPE_GENERAL))
                                        ?true
                                        :false}

                                />
                                <div>
                                    {   
                                        (((this.state.canBeDeleted === "Y" || !this.props.isUsedInTasks) &&
                                        !this.props.editTemplateItem.isFromRiskMaster &&
                                        (this.state.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN ||
                                        this.state.fieldType === TemplateConstants.FIELD_TYPE_SINGLE_SELECT ||
                                        this.state.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT ||
                                        this.state.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI ||
                                        this.state.fieldType === TemplateConstants.FIELD_TYPE_ISO)) &&
                                        this.props.editTemplateItem?.isResponsibilityField !== "Y") &&
                                        <div className="add-more-btn-layout m-t-10 align-items-center" onClick={this.handleAddEditDDValuesClick}>
                                            <span className="material-icons">add_circle</span>
                                            <p className="m-b-0">{!isEmptyArray(this.state.dropdownValues)?"Edit":"Add"} Values</p>
                                        </div>
                                    }
                                </div>
                                
                                {
                                    ((this.state.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN ||
                                    this.state.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI) &&
                                    this.props.editTemplateItem?.isResponsibilityField !== "Y") &&
                                    <div className="m-t-10">
                                        <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0 }}>
                                            <input
                                                type="checkbox"
                                                name="showDescription"
                                                id="showDescription"
                                                onChange={this.handleCheck}
                                                checked={this.state.showDescription === "Y" }
                                            />
                                            <label for="showDescription">Show description in dropdown</label>
                                        </FilterCheckBox>
                                    </div>
                                }
                                {
                                    !isEmptyVariable(this.state.formErrors['fieldType']) &&
                                    <span class="cm-error">{this.state.formErrors['fieldType']}</span>
                                }
                            </div>
                        }
                        {/* //here */}
                        {
                            this.state.fieldType === TemplateConstants.FIELD_TYPE_TABLE &&
                            this.props.templateType === TemplateConstants.TEMPLATE_TYPE_EX_TASK &&
                            <div class="addnew-modal-form-group">
                                <p>Linked Assigned Task*</p>
                                <RegularDropdown 
                                    placeholder={this.state.selectedExecTaskTableFieldName}
                                    dropdownArr={this.props.executeTableFields}
                                    labelParam="fieldName"
                                    onDropDownItemClick={this.execTaskTableDropdownClick}
                                    defaultPlaceholderDropDown = {execTaskTablePlaceholderText}
                                />
                                {
                                    !isEmptyVariable(this.state.formErrors['execTaskTableField']) &&
                                    <span class="cm-error">{this.state.formErrors['execTaskTableField']}</span>
                                }
                            </div>
                        }
                        {
                            this.state.fieldType === TemplateConstants.FIELD_TYPE_FRAMEWORK &&
                            <>
                                <div class="addnew-modal-form-group">
                                    <p>Framework Type*</p>
                                    <RegularDropdown
                                        placeholder={this.state.selectedFrameworkType}
                                        dropdownArr={this.state.frameworkTypeArr}
                                        labelParam="value"
                                        onDropDownItemClick={this.frameworkTypeDropdownClick}
                                        defaultPlaceholderDropDown={frameworkTypePlaceholderText}
                                    />
                                    <div>
                                    {  
                                        (this.state.fieldType === TemplateConstants.FIELD_TYPE_FRAMEWORK) &&
                                        this.state.selectedFrameworkType != frameworkTypePlaceholderText &&
                                        <div className="add-more-btn-layout m-t-10 align-items-center" onClick={this.handleAddFramework}>
                                            <span className="material-icons">add_circle</span>
                                            <p className="m-b-0">{isEmptyArray(this.state.selectedFrameworkObj)?"Add":"Edit"} Framework</p>
                                        </div>
                                    }
                                    </div>
                                    {
                                        !isEmptyVariable(this.state.formErrors['frameworkType']) &&
                                        <span class="cm-error">{this.state.formErrors['frameworkType']}</span>
                                    }
                                </div>
                                {/* {this.state.selectedFrameworkType != frameworkTypePlaceholderText &&
                                    <div class="addnew-modal-form-group">
                                        <p>Framework*</p>
                                        <ReactSelectDropdown
                                            handleReactSelectClose={this.frameworkDropdownClick}
                                            selectedDDObj= {this.state.selectedFrameworkObj}
                                            selectDropdownArr={this.state.frameworkArr}
                                            label={"frameworkName"}
                                            value={"frameworkId"}
                                            placeholder={this.state.selectedFramework}
                                            isMultiselect={true}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['framework']) &&
                                            <span class="cm-error">{this.state.formErrors['framework']}</span>
                                        }
                                    </div>
                                } */}
                            </>
                            }
                            {
                                this.state.fieldType === TemplateConstants.FIELD_TYPE_MASTER &&
                                <div class="addnew-modal-form-group">
                                    <p>Master Type*</p>
                                    <RegularDropdown
                                        placeholder={this.state.selectedMasterType}
                                        dropdownArr={TemplateConstants.MASTER_TYPE_ARR}
                                        labelParam="value"
                                        onDropDownItemClick={this.masterTypeDropdownClick}
                                        defaultPlaceholderDropDown={masterTypePlaceholderText}
                                    />
                                    {
                                        !isEmptyVariable(this.state.formErrors['masterType']) &&
                                        <span class="cm-error">{this.state.formErrors['masterType']}</span>
                                    }
                                </div>
                            }
                            {((this.state.fieldType === TemplateConstants.FIELD_TYPE_SCORE && !this.state.hasTaskTemplateScore) ||
                            this.state.fieldType === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE) &&
                            <div class="addnew-modal-form-group">
                                <p>{maximumScorePlaceholderText+"*"}</p>
                                <RegularDropdown 
                                    placeholder={this.state.selectedMaximumScore}
                                    dropdownArr={TemplateConstants.getMaxScoreArray(1,10)}
                                    labelParam="label"
                                    onDropDownItemClick={this.maxScoreDropdownClick}
                                    defaultPlaceholderDropDown={maximumScorePlaceholderText}
                                />
                                {
                                    !isEmptyVariable(this.state.formErrors['score']) &&
                                    <span class="cm-error">{this.state.formErrors['score']}</span>
                                }
                            </div>
                        }
                        {
                            this.state.fieldType === TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE &&
                            <div class="addnew-modal-form-group">
                                <p>{maximumWeightPlaceholderText+"*"}</p>
                                <RegularDropdown 
                                    placeholder={this.state.selectedMaximumWeight}
                                    dropdownArr={TemplateConstants.getMaxScoreArray(1,10)}
                                    labelParam="label"
                                    onDropDownItemClick={this.weightedScoreDropdownClick}
                                    defaultPlaceholderDropDown={maximumWeightPlaceholderText}
                                />
                                {
                                    !isEmptyVariable(this.state.formErrors['maximumWeight']) &&
                                    <span class="cm-error">{this.state.formErrors['maximumWeight']}</span>
                                }
                            </div>
                        }
                        <div class="addnew-modal-form-group">
                            {
                                this.state.fieldType === TemplateConstants.FIELD_TYPE_SCORE &&
                                <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0 }} 
                                    className={(this.state.canBeDeleted === "Y" &&
                                        this.props.addToPosition === "Right") ?"m-t-10":""}>
                                    <input 
                                        type="checkbox"
                                        name="isDecimalAllowed"
                                        id="isDecimalAllowed"
                                        onChange={this.handleCheck}
                                        checked={this.state.isDecimalAllowed === "Y"?true:false}
                                    />
                                    <label for="isDecimalAllowed">Decimal Allowed</label>
                                </FilterCheckBox>
                            }
                        </div>
                        {this.state.isDecimalAllowed === "Y" &&
                            this.state.fieldType === TemplateConstants.FIELD_TYPE_SCORE &&
                            <div class="addnew-modal-form-group">
                                <p>Decimal Allowed*</p>
                                <TableRadioButton
                                style={{marginLeft:10,display:"inline-flex"}}
                                themeSettings={this.props.themeSettings}>
                                    <input 
                                        type="checkbox"
                                        name={"any"}
                                        id={"any"}
                                        onChange={this.handleSelection}
                                        checked={this.state.selectedDecimalValue==="any"?true:false}
                                    />
                                    <label for={"any"} 
                                    style={{marginLeft:0}}>Any</label>
                                </TableRadioButton>
                                <TableRadioButton
                                style={{marginLeft:10,display:"inline-flex"}}
                                themeSettings={this.props.themeSettings}>
                                    <input 
                                        type="checkbox"
                                        name={"tenth"}
                                        id={"tenth"}
                                        onChange={this.handleSelection}
                                        checked={this.state.selectedDecimalValue==="tenth"?true:false}
                                    />
                                    <label for={"tenth"} 
                                    style={{marginLeft:0}}>Tenth</label>
                                </TableRadioButton>
                                <TableRadioButton
                                style={{marginLeft:10,display:"inline-flex"}}
                                themeSettings={this.props.themeSettings}>
                                    <input 
                                        type="checkbox"
                                        name={"quarter"}
                                        id={"quarter"}
                                        onChange={this.handleSelection}
                                        checked={this.state.selectedDecimalValue==="quarter"?true:false}
                                    />
                                    <label for={"quarter"} 
                                    style={{marginLeft:0}}>Quarter</label>
                                </TableRadioButton>
                                <TableRadioButton
                                style={{marginLeft:10,display:"inline-flex"}}
                                themeSettings={this.props.themeSettings}>
                                    <input 
                                        type="checkbox"
                                        name={"half"}
                                        id={"half"}
                                        onChange={this.handleSelection}
                                        checked={this.state.selectedDecimalValue==="half"?true:false}
                                    />
                                    <label for={"half"} 
                                    style={{marginLeft:0}}>Half</label>
                                </TableRadioButton>
                                {
                                    !isEmptyVariable(this.state.formErrors['decimalValue']) &&
                                    <span class="cm-error">{this.state.formErrors['decimalValue']}</span>
                                }
                            </div>
                        }
                        {   !this.state.hasTaskTemplateScore &&
                            !isEmptyVariable(this.state.selectedDecimalValue) && this.state.showScoreDescription &&
                            !isEmptyVariable(this.state.selectedMaximumScore) && this.state.selectedMaximumScore !== maximumScorePlaceholderText &&
                            <div className='add-desc' onClick={this.handleAddDescriptionClick}>
                                <span className="material-icons">add_circle</span>
                                <p style={{fontSize:14}}>Add Description</p>
                            </div>
                        }
                        {
                            this.state.fieldType !== TemplateConstants.FIELD_TYPE_TABLE &&
                            <div class="addnew-modal-form-group">
                                <p>Placeholder Value*</p>
                                <input type="text" placeholder="Enter placeholder value"
                                name="placeholderValue" value={this.state.placeholderValue} onChange={this.handleChange}/>
                                {
                                    !isEmptyVariable(this.state.formErrors['placeholderValue']) &&
                                    <span class="cm-error">{this.state.formErrors['placeholderValue']}</span>
                                }
                            </div>
                        }
                        {
                            this.state.fieldType === TemplateConstants.FIELD_TYPE_MASTER &&
                            <div class="addnew-modal-form-group">
                                <div className='d-flex mb-2'>
                                    <TableRadioButton style={{marginLeft:0,display:"inline-flex"}} themeSettings={this.props.themeSettings}>
                                        <input
                                            type="checkbox"
                                            name="Single-Select"
                                            id="masterSelectionSingle"
                                            onChange={this.handleMasterSelectionTypeChange}
                                            checked={this.state.masterSelectionType === "Single-Select"}
                                        />
                                        <label for="masterSelectionSingle" style={{marginLeft:0}}>Single-Select</label>
                                    </TableRadioButton>
                                    <TableRadioButton style={{marginLeft:10,display:"inline-flex"}} themeSettings={this.props.themeSettings}>
                                        <input
                                            type="checkbox"
                                            name="Multi-Select"
                                            id="masterSelectionMulti"
                                            onChange={this.handleMasterSelectionTypeChange}
                                            checked={this.state.masterSelectionType === "Multi-Select"}
                                        />
                                        <label for="masterSelectionMulti" style={{marginLeft:0}}>Multi-Select</label>
                                    </TableRadioButton>
                                </div>
                                {
                                    !isEmptyVariable(this.state.formErrors['masterSelectionType']) &&
                                    <span class="cm-error">{this.state.formErrors['masterSelectionType']}</span>
                                }
                            </div>
                        }
                        <div class="addnew-modal-form-group">
                            {
                                this.getNotRequiredOptionDisplayFlag() && 
                                // this.props.templateType !== TemplateConstants.TEMPLATE_TYPE_EX_TASK) &&
                                <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0 }}>
                                    <input
                                        type="checkbox"
                                        name="notRequiredOption_NR"
                                        id="notRequiredOption_NR"
                                        onChange={this.handleCheck}
                                        checked={this.state.notRequiredOption_NR === "Y" ? true : false}
                                    />
                                    <label for="notRequiredOption_NR">Show "Not Required" option</label>
                                </FilterCheckBox>
                            }
                            {
                                this.state.canBeDeleted === "Y" && 
                                (this.state.fieldType !== TemplateConstants.FIELD_TYPE_TABLE ||
                                this.props.templateType !== TemplateConstants.TEMPLATE_TYPE_AUDITEE_COMMENT) &&
                                <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0 }} 
                                    className={(this.state.canBeDeleted === "Y" &&
                                        this.props.addToPosition === "Right") ?"m-t-10":""}>
                                    <input 
                                        type="checkbox"
                                        name="isMandatorySelected"
                                        id="isMandatorySelected"
                                        onChange={this.handleCheck}
                                        checked={this.state.isMandatorySelected === "Y"?true:false}
                                    />
                                    <label for="isMandatorySelected">Mandatory</label>
                                </FilterCheckBox>
                            }
                            {
                                (this.state.fieldType === TemplateConstants.FIELD_TYPE_SINGLE_SELECT ||
                                this.state.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT ||
                                this.state.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI) &&
                                <div>
                                    <div className="d-flex align-items-center">
                                        <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0, marginRight: 10 }}>
                                            <input
                                                type="checkbox"
                                                name="showDescriptionSeparator"
                                                id="showDescriptionSeparator"
                                                onChange={this.handleCheck}
                                                checked={this.state.showDescriptionSeparator === "Y"}
                                            />
                                            <label for="showDescriptionSeparator">Show Description Also Separator</label>
                                        </FilterCheckBox>
                                        <input
                                            type="text"
                                            placeholder="Enter Separator"
                                            name="descriptionSeparator"
                                            style={{maxWidth:120}}
                                            value={this.state.descriptionSeparator}
                                            onChange={this.handleDescriptionSeparatorChange}
                                            disabled={this.state.showDescriptionSeparator !== "Y"}
                                        />
                                    </div>
                                    {
                                        !isEmptyVariable(this.state.formErrors['descriptionSeparator']) &&
                                        <span class="cm-error">{this.state.formErrors['descriptionSeparator']}</span>
                                    }
                                    <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0 }}>
                                        <input
                                            type="checkbox"
                                            name="showOnlyDescription"
                                            id="showOnlyDescription"
                                            onChange={this.handleCheck}
                                            checked={this.state.showOnlyDescription === "Y"}
                                        />
                                        <label for="showOnlyDescription">Show Only Description</label>
                                    </FilterCheckBox>
                                </div>
                            }
                            {
                                this.props.templateType === TemplateConstants.TEMPLATE_TYPE_AUDITEE_COMMENT &&
                                <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0 }}
                                className={"m-t-10"}>
                                    <input
                                        type="checkbox"
                                        name="userOnlyField"
                                        id="userOnlyField"
                                        onChange={this.handleCheck}
                                        checked={this.state.userOnlyField === "Y" ? true : false}
                                    />
                                    <label for="userOnlyField">User only field</label>
                                </FilterCheckBox>
                            }
                            {
                                this.state.canBeDeleted === "Y" &&
                                this.state.fieldType === TemplateConstants.FIELD_TYPE_TABLE &&
                                this.props.templateType === TemplateConstants.TEMPLATE_TYPE_TASK &&
                                <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0 }} 
                                    className={(this.state.canBeDeleted === "Y" &&
                                        this.props.addToPosition === "Right") ?"m-t-10":""}>
                                    <input 
                                        type="checkbox"
                                        name="isUsedForExec"
                                        id="isUsedForExec"
                                        onChange={this.handleCheck}
                                        checked={this.state.isUsedForExec === "Y"?true:false}
                                    />
                                    <label for="isUsedForExec">Used In Execute Task</label>
                                </FilterCheckBox>
                            }
                            {
                                this.state.fieldType === TemplateConstants.FIELD_TYPE_MASTER &&
                                <div className="addnew-modal-form-group" style={{marginTop:8}}>
                                    {
                                        this.isEmployeeMasterType() ?
                                        <div className='d-flex align-items-center mb-1' style={{flexWrap:"wrap"}}>
                                            <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0, marginRight: 20 }}>
                                                <input
                                                    type="checkbox"
                                                    name="masterShowEmployeeTitle"
                                                    id="masterShowTitleCheck"
                                                    checked={this.state.masterShowEmployeeTitle === "Y"}
                                                    disabled={true}
                                                    readOnly
                                                />
                                                <label for="masterShowTitleCheck">Title</label>
                                            </FilterCheckBox>
                                            <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0, marginRight: 20 }}>
                                                <input
                                                    type="checkbox"
                                                    name="masterShowEmployeeName"
                                                    id="masterShowEmployeeNameCheck"
                                                    onChange={this.handleMasterEmployeeFieldCheck}
                                                    checked={this.state.masterShowEmployeeName === "Y"}
                                                />
                                                <label for="masterShowEmployeeNameCheck">Name</label>
                                            </FilterCheckBox>
                                            <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0 }}>
                                                <input
                                                    type="checkbox"
                                                    name="masterShowEmployeeDesignation"
                                                    id="masterShowEmployeeDesignationCheck"
                                                    onChange={this.handleMasterEmployeeFieldCheck}
                                                    checked={this.state.masterShowEmployeeDesignation === "Y"}
                                                />
                                                <label for="masterShowEmployeeDesignationCheck">Designation</label>
                                            </FilterCheckBox>
                                        </div>
                                        :
                                        <>
                                        <div className='d-flex align-items-center mb-1' style={{flexWrap:"nowrap"}}>
                                            <div className='d-flex align-items-center' style={{marginRight:12}}>
                                                <p className='m-b-0' style={{marginRight:6}}>Name</p>
                                                <input
                                                    type="text"
                                                    placeholder="Order"
                                                    style={{width:45,maxWidth:45,padding:"4px 6px"}}
                                                    name="masterNameOrder"
                                                    value={this.state.masterNameOrder}
                                                    onChange={this.handleMasterOrderChange}
                                                    maxLength={1}
                                                />
                                            </div>
                                            <div className='d-flex align-items-center' style={{marginRight:12}}>
                                                <p className='m-b-0' style={{marginRight:6}}>Short Name</p>
                                                <input
                                                    type="text"
                                                    placeholder="Order"
                                                    style={{width:45,maxWidth:45,padding:"4px 6px"}}
                                                    name="masterShortNameOrder"
                                                    value={this.state.masterShortNameOrder}
                                                    onChange={this.handleMasterOrderChange}
                                                    maxLength={1}
                                                />
                                            </div>
                                            <div className='d-flex align-items-center'>
                                                <p className='m-b-0' style={{marginRight:6}}>Description</p>
                                                <input
                                                    type="text"
                                                    placeholder="Order"
                                                    style={{width:45,maxWidth:45,padding:"4px 6px"}}
                                                    name="masterDescriptionOrder"
                                                    value={this.state.masterDescriptionOrder}
                                                    onChange={this.handleMasterOrderChange}
                                                    maxLength={1}
                                                />
                                            </div>
                                        </div>
                                        <p className='m-b-0' style={{fontSize:12,color:"#888"}}>(select order by typing number from 1 to 3)</p>
                                        </>
                                    }

                                    <div className="d-flex align-items-center mt-1">
                                        <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0, marginRight: 10 }}>
                                            <input
                                                type="checkbox"
                                                name="masterShowDisplaySeparator"
                                                id="masterShowDisplaySeparator"
                                                onChange={this.handleCheck}
                                                checked={this.state.masterShowDisplaySeparator === "Y"}
                                                disabled={this.isEmployeeMasterType() && this.state.masterShowEmployeeDesignation !== "Y"}
                                            />
                                            <label for="masterShowDisplaySeparator">{this.isEmployeeMasterType() ? "Display Separator (For Designation)" : "Display Separator"}</label>
                                        </FilterCheckBox>
                                        <input
                                            type="text"
                                            placeholder="Enter Separator"
                                            style={{maxWidth:120}}
                                            name="masterDisplaySeparator"
                                            value={this.state.masterDisplaySeparator}
                                            onChange={this.handleMasterDisplaySeparatorChange}
                                            disabled={this.state.masterShowDisplaySeparator !== "Y"}
                                        />
                                    </div>
                                    {
                                        !isEmptyVariable(this.state.formErrors['masterDisplaySeparator']) &&
                                        <span class="cm-error">{this.state.formErrors['masterDisplaySeparator']}</span>
                                    }

                                    <p className='mt-2 mb-1'>Remarks:</p>
                                    <div className='d-flex mb-1'>
                                        <TableRadioButton style={{marginLeft:0,display:"inline-flex"}} themeSettings={this.props.themeSettings}>
                                            <input
                                                type="checkbox"
                                                name="Individual"
                                                id="masterRemarksIndividual"
                                                onChange={this.handleMasterRemarksTypeChange}
                                                checked={this.state.masterRemarksType === "Individual"}
                                            />
                                            <label for="masterRemarksIndividual" style={{marginLeft:0}}>Individual</label>
                                        </TableRadioButton>
                                        {
                                            this.state.masterSelectionType === "Multi-Select" &&
                                            <TableRadioButton style={{marginLeft:10,display:"inline-flex"}} themeSettings={this.props.themeSettings}>
                                                <input
                                                    type="checkbox"
                                                    name="Single"
                                                    id="masterRemarksSingle"
                                                    onChange={this.handleMasterRemarksTypeChange}
                                                    checked={this.state.masterRemarksType === "Single"}
                                                />
                                                <label for="masterRemarksSingle" style={{marginLeft:0}}>Single</label>
                                            </TableRadioButton>
                                        }
                                    </div>
                                </div>
                            }
                            {
                                this.props.templateType === TemplateConstants.TEMPLATE_TYPE_OBSERVATION &&
                                <>
                                <p className='mt-3'>Configure Download Report</p>
                                {
                                // (this.state.observationHeadingFormat.bold || this.state.observationHeadingFormat.italic || 
                                // this.state.observationHeadingFormat.underline) && 
                                (!this.props.obsHeadingField || 
                                this.props.editTemplateItem.fieldId === this.props.obsHeadingField) &&
                                    <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0 }} 
                                        className={"m-t-10"}>
                                        <input 
                                            type="checkbox"
                                            name="observationHeading"
                                            id="observationHeading"
                                            onChange={this.handleCheck}
                                            checked={this.state.observationHeading === "Y"?true:false}
                                        />
                                        <label for="observationHeading">Observation Heading</label>
                                    </FilterCheckBox>
                                }
                                {this.state.observationHeading === "Y" &&
                                    <div className='d-flex mb-3'>
                                        <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0, marginRight: 10 }} 
                                            className={"m-t-10"}>
                                            <input 
                                                type="checkbox"
                                                name="bold"
                                                id="bold"
                                                onChange={this.handleObservationHeadingCheck}
                                                checked={this.state.observationHeadingFormat.bold}
                                            />
                                            <label for="bold">Bold</label>
                                        </FilterCheckBox>
                                        <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0, marginRight: 10 }} 
                                            className={"m-t-10"}>
                                            <input 
                                                type="checkbox"
                                                name="italic"
                                                id="italic"
                                                onChange={this.handleObservationHeadingCheck}
                                                checked={this.state.observationHeadingFormat.italic}
                                            />
                                            <label for="italic">Italic</label>
                                        </FilterCheckBox>
                                        <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0 }} 
                                            className={"m-t-10"}>
                                            <input 
                                                type="checkbox"
                                                name="underline"
                                                id="underline"
                                                onChange={this.handleObservationHeadingCheck}
                                                checked={this.state.observationHeadingFormat.underline}
                                            />
                                            <label for="underline">Underline</label>
                                        </FilterCheckBox>
                                    </div>
                                }
                                <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0, marginTop: 10 }} 
                                    className={"m-t-10"}>
                                    <input 
                                        type="checkbox"
                                        name="showFieldHeading"
                                        id="showFieldHeading"
                                        onChange={this.handleCheck}
                                        checked={this.state.showFieldHeading === "Y"?true:false}
                                    />
                                    <label for="showFieldHeading">Show Field Heading</label>
                                </FilterCheckBox>
                                {
                                    this.state.fieldType === TemplateConstants.FIELD_TYPE_TEXT &&
                                    <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0 }} 
                                        className={"m-t-10"}>
                                        <input 
                                            type="checkbox"
                                            name="executiveSummary"
                                            id="executiveSummary"
                                            onChange={this.handleCheck}
                                            checked={this.state.executiveSummary === "Y"?true:false}
                                        />
                                        <label for="executiveSummary">Executive Summary</label>
                                    </FilterCheckBox>
                                }
                                {   this.props?.assignRisk === "Y" &&
                                    this.state.fieldType === TemplateConstants.FIELD_TYPE_TEXT &&
                                    <FilterCheckBox themeSettings={this.props.themeSettings} style={{ marginLeft: 0 }} 
                                        className={"m-t-10"}>
                                        <input 
                                            type="checkbox"
                                            name="riskLevelExecutiveSummary"
                                            id="riskLevelExecutiveSummary"
                                            onChange={this.handleCheck}
                                            checked={this.state.riskLevelExecutiveSummary === "Y"?true:false}
                                        />
                                        <label for="riskLevelExecutiveSummary">Risk Level Executive Summary</label>
                                    </FilterCheckBox>
                                }
                                </>
                            }
                            {
                                this.state.fieldType === TemplateConstants.FIELD_TYPE_MASTER &&
                                this.props.templateType === TemplateConstants.TEMPLATE_TYPE_GENERAL &&
                                <p className='mt-3'>Configure Download Report</p>
                            }
                            {
                                this.state.fieldType === TemplateConstants.FIELD_TYPE_MASTER &&
                                (this.props.templateType === TemplateConstants.TEMPLATE_TYPE_OBSERVATION ||
                                this.props.templateType === TemplateConstants.TEMPLATE_TYPE_GENERAL) &&
                                <div style={{marginTop:16}}>
                                    {
                                        this.isEmployeeMasterType() ?
                                        <>
                                        {this.renderMasterFormatRow("Title","masterReportTitleFormat")}
                                        {this.renderMasterFormatRow("Name","masterReportEmployeeNameFormat")}
                                        {this.renderMasterFormatRow("Designation","masterReportDesignationFormat")}
                                        </>
                                        :
                                        <>
                                        {this.renderMasterFormatRow("Name","masterReportNameFormat")}
                                        {this.renderMasterFormatRow("Short Name","masterReportShortNameFormat")}
                                        {this.renderMasterFormatRow("Description","masterReportDescriptionFormat")}
                                        </>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <div class="modal-close-save">
                        <div class="close-save-col">
                            <button onClick={this.handleCreateDialogClose} type="button" class="modal-close">Cancel</button>
                            <DialogSaveButton themeSettings={this.props.themeSettings} onClick={this.handleCreateField} type="button">Save</DialogSaveButton>
                        </div>
                    </div>

                    <AddDropdownValuesDialog
                        isEdit={this.state.isDDValuesEdit}
                        showCreateDDValueDialog = {this.state.showCreateDDValueDialog}
                        handleCreateDDValueDialogClose = {this.handleCreateDDValueDialogClose}
                        themeSettings={this.props.themeSettings}
                        addToPosition={this.props.addToPosition}
                        typeDDValueArr = {this.state.dropdownValues}
                        fieldType={this.state.fieldType}
                    />

                    <AddDescriptionDialog
                        showDescriptionDialog={this.state.showDescriptionDialog}
                        themeSettings={this.props.themeSettings}
                        handleDescriptionDialogClose={this.handleDescriptionDialogClose}
                        handleSaveDescription={this.handleSaveDescription}
                        descriptions={this.state.descriptions}
                        scores={this.state.scores}
                        selectedMaximumScore={this.state.selectedMaximumScore}
                        selectedDecimalValue={this.state.selectedDecimalValue}
                    />

                    <AddFrameworkDialog
                        showFramework={this.state.showFramework}
                        handleFrameworkDialogClose={this.handleFrameworkDialogClose}
                        isEdit={this.props.isEdit}
                        frameworkArr={this.state.frameworkArr}
                        themeSettings={this.props.themeSettings}
                        selectedFrameworkObj={this.state.selectedFrameworkObj}
                    />
                </div>
                
            </Modal>
        );
    }
}

export default AddFieldDialog;